import {call, put} from "redux-saga/effects";
import {fetchShipmentByAccountNumber} from "../api/shipmentByAccountNumberApi";
import {
  receiveShipmentData, noResultsShipmentData, receiveNotFoundShipmentIds
} from "../actions/shipmentDataActions";
import {history} from "../store";
import {serviceErrorShipmentByAccountNumber} from "../actions/shipmentDataByAccountNumberActions";

export default function* getShipmentByAccountNUmber(action) {
  try {
    const data = yield call(fetchShipmentByAccountNumber, action.payload);

    if(data === undefined) {
      return;
    }

    if(data.length === 0) {
      yield put(noResultsShipmentData());
    } else {
      data.forEach(function(awb, index) {
          // Handle both old (PascalCase) and new (camelCase) API formats
          awb.awbNumber = awb.awbNumber || awb.AWBNumber || awb.awbnumber;
          awb.awbPrefix = awb.awbPrefix || awb.AWBPrefix || awb.awbprefix;
          awb.awbCreateDate = awb.awbCreateDate || awb.AWBCreateDate || awb.awbcreateDate;
          this[index] = awb;
      }, data);
      console.log(data);
      yield put(receiveShipmentData(data));
      yield put(receiveNotFoundShipmentIds([]));

      history.push({
        pathname: '/manage/tracking/tracking-results'
      });
    }
  } catch (e) {
    yield put(serviceErrorShipmentByAccountNumber());
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/shipmentByAccountNumberSaga.js